module.exports = __webpack_public_path__ + "img/map-hybrid.2416de77.png";